export default "__VITE_ASSET__C_sej0Qf__"